import { useQuery } from "react-query";
import { PaginateResult } from "resources/types/shared";
import http from "infra/http";
import { AxiosError } from "axios";
import {
  OrcamentoDto,
  FiltroOrcamentos,
} from "core/features/orcamento/typings";

export function useListarOrcamentos(query: FiltroOrcamentos) {
  return useQuery<PaginateResult<OrcamentoDto>, AxiosError>(
    [`/v1/orcamento`, query],
    async () => {
      const { data } = await http.get<PaginateResult<OrcamentoDto>>(
        "/v1/orcamento",
        {
          params: query,
        }
      );

      return data;
    }
  );
}
